class InfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.anchor = this.querySelector('a');
    if (!this.anchor) return;

    this.observer = new IntersectionObserver(
      entries => entries[0].isIntersecting && this.loadNextPage(),
      { rootMargin: '400px' }
    );
    this.observer.observe(this);
  }

  // Theme's filter/sort reload replaces .collection__dynamic-part wholesale.
  // Without this, the orphaned observer keeps appending stale pages.
  disconnectedCallback() {
    this.observer && this.observer.disconnect();
  }

  async loadNextPage() {
    this.observer.disconnect();

    const label = this.anchor.innerText;
    this.anchor.innerText = 'Loading More...';

    // ponytail: Section Rendering API instead of the full page — same trick the
    // theme's own _reload() uses. Drop back to this.anchor.href if it ever misbehaves.
    const url = new URL(this.anchor.href, location.origin);
    const section = this.closest('[data-section-type="collection"]');
    if (section) url.searchParams.set('section_id', section.dataset.sectionId);

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = document.querySelector('[data-product-grid]');
      const newGrid = doc.querySelector('[data-product-grid]');
      if (!grid || !newGrid) throw new Error('product grid not found');

      grid.append(...newGrid.children);

      const next = doc.querySelector('infinite-scroll');
      next ? this.replaceWith(next) : this.remove();
    } catch (err) {
      console.error('InfiniteScroll:', err);
      // Leave it as a plain working link rather than a dead hidden button.
      this.anchor.innerText = label;
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);